import { createGlobalStyle } from 'styled-components';

import Inter from '../../assets/fonts/Inter/Inter-VariableFont_slnt,wght.ttf';

export default createGlobalStyle`
  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 200;
    font-style: normal;
  }


  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 500;
    font-style: normal;
  }


  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 600;
    font-style: normal;
  }


  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 700;
    font-style: normal;
  }


  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 800;
    font-style: normal;
  }


  @font-face {
    font-family: 'Inter';
    src: local('Inter'), local('Inter'),
    url(${Inter}) format('ttf'),
    url(${Inter}) format('ttf');
    font-weight: 900;
    font-style: normal;
  }
`;
